(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["join-collective"] && !Shopify.designMode) return;
  try {
    
  window.fd('form', {
    formId: '6921e81d2fda04da828f214a',
    containerEl: '#fd-form-6921e81d2fda04da828f214a'
  });

  } catch(e) { console.error(e); }
})();
})();
